"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This component is used internally to display links inside the Navigation component.
 */
const NavigationLink = _ref => {
  let {
    generateLink,
    link
  } = _ref;
  // const ariaCurrent = isSelected ? "page" : undefined;
  if (generateLink) {
    const {
      isSelected,
      ...linkProps
    } = link;
    // If a function has been provided then use it to generate the link element.
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, generateLink({
      isSelected,
      "aria-current": isSelected ? "page" : undefined,
      ...linkProps
    }));
  } else if ((0, _utils.isNavigationAnchor)(link)) {
    const {
      isSelected,
      label,
      url,
      ...linkProps
    } = link;
    return /*#__PURE__*/_react.default.createElement("a", _extends({}, linkProps, {
      href: url,
      "aria-current": isSelected ? "page" : undefined
    }), label);
  } else if ((0, _utils.isNavigationButton)(link)) {
    const {
      isSelected,
      label,
      url: _url,
      ...linkProps
    } = link;
    return /*#__PURE__*/_react.default.createElement("button", _extends({}, linkProps, {
      "aria-current": isSelected ? "page" : undefined
    }), label);
  }
  return null;
};
var _default = exports.default = NavigationLink;